<template>
  <div>
    <h1 class="mb-8 font-bold text-3xl">
      <inertia-link class="text-indigo-400 hover:text-indigo-600" :href="route('contacts')">Customer:</inertia-link>
      <span class="text-indigo-400 font-medium">/</span>
      {{ form.nombres}} {{ form.apellidos }}
    </h1>
    <trashed-message v-if="contact.deleted_at" class="mb-6" @restore="restore">
     Customer Removed!
    </trashed-message>
    <div class="bg-white rounded-md shadow overflow-hidden max-w-3xl">
      <form @submit.prevent="update">
        <div class="p-8 -mr-6 -mb-8 flex flex-wrap">
           <text-input v-model="form.nombres" :error="form.errors.nombres" class="pr-6 pb-8 w-full lg:w-1/2" label="First Name" />
          <text-input v-model="form.apellidos" :error="form.errors.apellidos" class="pr-6 pb-8 w-full lg:w-1/2" label="Last Name" />
          <text-input v-model="form.direccion" :error="form.errors.direccion" class="pr-6 pb-8 w-full lg:w-1/1" label="Address" />
          <text-input v-model="form.email" :error="form.errors.email" class="pr-6 pb-8 w-full lg:w-1/2" label="E-mail" />
          <text-input v-model="form.telefono" :error="form.errors.telefono" class="pr-6 pb-8 w-full lg:w-1/2" label="Phone" />
        </div>
        <div class="px-8 py-4 bg-gray-50 border-t border-gray-100 flex items-center">
          <button v-if="!contact.deleted_at" class="text-red-600 hover:underline" tabindex="-1" type="button" @click="destroy">Delete Customer</button>
          <loading-button :loading="form.processing" class="btn-indigo ml-auto" type="submit">Saved Customer</loading-button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import Layout from '@/Shared/Layout'
import TextInput from '@/Shared/TextInput'
import SelectInput from '@/Shared/SelectInput'
import LoadingButton from '@/Shared/LoadingButton'
import TrashedMessage from '@/Shared/TrashedMessage'

export default {
  metaInfo() {
    return {
      title: `${this.form.nombres} ${this.form.apellidos}`,
    }
  },
  components: {
    LoadingButton,
    SelectInput,
    TextInput,
    TrashedMessage,
  },
  layout: Layout,
  props: {
    contact: Object,
    organizations: Array,
  },
  remember: 'form',
  data() {
    return {
      form: this.$inertia.form({
        nombres: this.contact.nombres,
        apellidos: this.contact.apellidos,
        organization_id: this.contact.organization_id,
       direccion: this.contact.direccion,
        email: this.contact.email,
        telefono: this.contact.telefono,
        estado: this.contact.estado,

      }),
    }
  },
  methods: {
    update() {
      this.form.put(this.route('contacts.update', this.contact.id))
    },
    destroy() {
      if (confirm('Estas Seguro de Eliminar?')) {
        this.$inertia.delete(this.route('contacts.destroy', this.contact.id))
      }
    },
    restore() {
      if (confirm('Piensalo Bien!?')) {
        this.$inertia.put(this.route('contacts.restore', this.contact.id))
      }
    },
  },
}
</script>
